import { Component, OnInit,ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { PositionService} from '../services/position.service';
import { DeviceService } from '../services/device.service';
import { UserService } from '../services/user.service';
import { Message } from 'primeng/primeng';
import { AddressService } from '../services/address.service';
import { Table } from 'primeng/components/table/table';
import * as XLSX from 'xlsx';
import { environment} from '../../environments/environment';

@Component({
  selector: 'app-excess-speed-report',
  templateUrl: './excess-speed-report.component.html',
  styleUrls: ['./excess-speed-report.component.css']
})
export class ExcessSpeedReportComponent implements OnInit {
  fileName:String;
  displayLocation: boolean=false;
  options: any;
  overlays: any[];
  position:any;
  speed: number;
  positions : any [];
  devices: SelectItem[];
  dateOptions: SelectItem[];
  dateOption: any;
  idDevice: String;
  disabledInitialDate: boolean;
  disabledFinalDate: boolean;
  initialDate: Date;
  finalDate: Date;
  msgs: Message[] = [];
  blockedDocument: boolean = false;
  cols: any[];
  maxDays:number=35;

  @ViewChild('dt') table: Table;

  constructor(private positionService:PositionService,private deviceService : DeviceService,
    private userService: UserService,private addressService:AddressService) { }

    ngOnInit() {
      this.cols = [
              { field: 'nameDevice', header: 'NOMBRE' },
              { field: 'deviceTime', header: 'FECHA/HORA' },
              { field: 'speed', header: 'VELOCIDAD (km/hr)' },
              { field: 'latLng', header: 'POSICION' },
              { field: 'address', header: 'DIRECCION' }
          ];
      this.dateOptions = [
        {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
        {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
        {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
        {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
      ];

      this.devices = [];
      this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
        let response: any = data;
        response.devices.forEach(item => {
          this.devices.push({label: item.name, value: item.idDevice});
        });
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
      this.speed = 60;
      this.dateOption = '7';
      this.changeDate();
    }

    changeDate(){
      this.disabledInitialDate = true;
      this.disabledFinalDate = true;
      let dateTime = new Date();
      if(this.dateOption == 'T'){
        this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 0, 0, 0));
        this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
      }else if(this.dateOption == 'Y'){
        this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 1, 0, 0, 0));
        this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 1, 23, 59, 59));
      }else if(this.dateOption == '7'){
        this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 6, 0, 0, 0));
        this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
      }else{
        this.disabledInitialDate = false;
        this.disabledFinalDate = false;
      }
    }

    diferenciaEntreFechasEnDias(a:Date, b:Date):number{
      return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
    }

    buscar(){
      if(this.table){
        this.table.first=1;
      }
      this.fileName="ExcesoVelocidades_";
      this.devices.forEach(item =>{
        if(item.value == this.idDevice){
          this.fileName = this.fileName+item.label;
        }
      });
      if(this.diferenciaEntreFechasEnDias(this.initialDate,this.finalDate) > this.maxDays){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"El rango de fechas no debe exceder los "+this.maxDays+" dias"}];
        return;
      }
      if(this.initialDate >= this.finalDate){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"La fecha final debe ser superior a la fecha inicial"}];
        return;
      }
      this.blockedDocument = true;
      this.positions = [];
      this.positionService.findBySpeed(this.idDevice,this.initialDate,this.finalDate,this.speed).then(data => {
        let response: any = data;
        response.positions.forEach(item => {
            item.latitude = item.latitude.toFixed(6);
            item.longitude = item.longitude.toFixed(6);
            item.speed = item.speed.toFixed(2);
            item.latLng = item.latitude+", "+item.longitude
            this.positions.push(item);
        });
        this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });

    }
    showInMap(position:any){
      this.overlays = [];
      this.displayLocation = true;
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);
      this.options = {
        zoom: 13,
        center:latLng
      };
      let marker = new google.maps.Marker({position: latLng});
      this.position = position;
      this.overlays.push(marker);
    }

    hide(){
      this.displayLocation = false;
    }

    getAddress(position:any){
      this.blockedDocument = true;
      this.addressService.findAddressByCoordinates(position).then(data =>{
        let response: any = data;
          if(response.status == 'OK'){
            position.address = response.address;
            this.msgs = [{severity:'info', summary:'INFO', detail:'Dirección obtenida Exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });;
    }

    exportXLS(){
      let records = [];
      this.positions.forEach(item=>{
        let data = {};
        this.cols.forEach(col => {
          data[col.header] = item[col.field];
        });
        records.push(data);
      });

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
      const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
      XLSX.writeFile(workbook, this.fileName+".xlsx");
    }

    exportPDF(){
      window.open(environment.reportsEndPoint+"viewExcessSpeedReport?idDevice="+this.idDevice+"&startDate="+this.initialDate.toISOString()+"&endDate="+this.finalDate.toISOString()+"&speed="+this.speed, "_blank");
    }
}



// WEBPACK FOOTER //
// ./src/app/excess-speed-report/excess-speed-report.component.ts